import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-green-950 text-center text-stone-50" aria-label="Limited time offer" data-id="element-284" data-mp="369pga49jt16e">
      <div className="h-1.5 w-full bg-amber-500" aria-hidden="true" data-id="element-285" data-mp="31jhfqc1uokv8" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-286" data-mp="31h4nn62dou4g">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-287" data-mp="3g7c97unomt9d">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="3b894kbbm6p1x" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-289" data-mp="3p7iggyssex03" />
        <p className="mt-7 font-bold text-green-100" data-id="element-290" data-mp="3p6h48r01c4gs">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-stone-50/10 bg-green-900 p-4 text-sm" data-id="element-291" data-mp="1uuixcvp77ko2">
          <p className="font-bold text-stone-50" data-id="element-292" data-mp="1qtp8o03xm1u4">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-amber-400" data-id="element-293" data-mp="1qv0b9wln53jn" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-green-950" data-id="element-294" data-mp="2xtssrr8cac8d">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-amber-500" data-id="element-295" data-mp="32rc68ox7qkz9" />
          </div>
          <p className="mt-1 text-right text-xs text-green-100" data-id="element-296" data-mp="3gipjjl4j2mlu">66% of spots taken</p>
        </div>
      </div>
      <div className="h-1.5 w-full bg-stone-500" aria-hidden="true" data-id="element-297" data-mp="3ljdc4b8enbi6" />
    </section>;
}